// IMPORTS
import { cva } from "class-variance-authority";

const containerStyles = cva("mx-auto w-full", {
  variants: {
    width: {
      sm: "max-w-4xl",
      md: "max-w-5xl",
      lg: "max-w-6xl",
      xl: "max-w-7xl",
      "2xl": "max-w-8xl",
      "3xl": "max-w-10xl",
      full: "max-w-none",
    },
    overflow: {
      true: "overflow-visible",
      false: "overflow-hidden lg:overflow-visible",
    },
    padding: {
      true: "px-4 lg:px-6",
      false: "",
    },
    fullHeight: {
      true: "h-full",
      false: "",
    },
  },
  defaultVariants: {
    width: "2xl",
    overflow: false,
    padding: true,
  },
});

// Container
export function Container({
  children,
  width,
  overflow = false,
  padding = true,
  fullHeight = false,
}) {
  // Render
  return (
    <div
      data-component="Container"
      className={containerStyles({
        width,
        overflow,
        padding,
        fullHeight,
      })}
    >
      {children}
    </div>
  );
}
